export default "__VITE_ASSET__i6XGQD97__"